import * as React from 'react';
import { Input } from '@mui/base/Input';
import { styled } from '@mui/system';
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography';

const blue = {
	100: '#DAECFF',
	200: '#80BFFF',
	400: '#3399FF',
	600: '#0072E5',
};

const grey = {
	50: '#F3F6F9',
	100: '#E7EBF0',
	200: '#E0E3E7',
	300: '#CDD2D7',
	400: '#B2BAC2',
	500: '#A0AAB4',
	600: '#6F7E8C',
	700: '#3E5060',
	800: '#2D3843',
	900: '#1A2027',
};

const StyledInputElement = styled('textarea')(
	({ theme }) => `
  width: -webkit-fill-available;
  font-size: 0.875rem;
  font-family: IBM Plex Sans, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[300]};
  border-radius: 8px;
  padding: 12px 12px;

  &:hover {
    background: ${theme.palette.mode === 'dark' ? '' : grey[100]};
    border-color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
  }

  &:focus {
    outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : blue[100]};
  }
`,
);

const CustomInput = React.forwardRef(function CustomInput(props, ref) {
	return (
		<Box sx={{display: 'grid', gap: 1}}>
			<Typography letterSpacing={'-0.05em'} variant="span"><strong>{props.label}</strong></Typography>
			<StyledInputElement components={{ Input: StyledInputElement }} {...props} ref={ref} /></Box>
	);
});

export default CustomInput;